import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailRelatedContainer = styled.div<React.CSSProperties>`
  position: fixed;
  left: ${40 * Screen.widthRatio}px;
  top: ${509 * Screen.widthRatio}px;
`;

export default DetailRelatedContainer;
